import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AuctionUpdatedSummaryData } from '../types/auctionSummary.type'

type UseAuctionUpdatedSummaryProps = {
  id?: string
  options?: Partial<
    Omit<
      UseQueryOptions<{ data: { data: AuctionUpdatedSummaryData } }, unknown, AuctionUpdatedSummaryData>,
      'queryKey' | 'queryFn'
    >
  >
}

export const useAuctionUpdatedSummary = ({ id, options }: UseAuctionUpdatedSummaryProps) => {
  const privateAxios = usePrivateAxios()

  return useQuery({
    enabled: false,
    queryKey: ['maintenanceAuctionUpdatedSummary', id],
    queryFn: () =>
      privateAxios.get(`/maintenance/establishment_choice/auction_entries/${id}/updated_summary`),
    select: (response: { data: { data: AuctionUpdatedSummaryData } }) => response?.data?.data,
    ...options,
  })
}
